export default {"src":"/_next/static/media/trash.a6ec1dc8.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};